export default function initregistration(){
    //TODO: Die näcshten 70 Zeilen sind nur für Tooltips in der Registrierung. Spätestens mit Mein-CC Relaunch entfernen
    let uniqueId = 0;

    //Help popup
    //$(".hover-help").uniqueId();

    $(".hover-help").each(function() {
        $(this).attr('id','ui-id-' + uniqueId++);
    });
    $("#reg-kundennummer").on("click",function () {
        $("#reg-kundeyes").prop("checked", true);
    });
    const positionPopup = function (helpsign, popup) {
        if (helpsign.length > 0 && popup.length >= 0) {
            var offset = helpsign.offset();

            //Move to correct position
            var addLeft = helpsign.width();
            var subtractTop = popup.outerHeight();
            if (window.innerWidth <= 719) {
                popup.css("left", 0);
                popup.css("right", 0);
                popup.css("max-width", "none");
                subtractTop = subtractTop + 16;
            }
            else {
                popup.css("left", offset.left + addLeft);
                popup.css("max-width", "600px");
            }
            popup.css("top", offset.top - subtractTop);

            //recalculate position in case window is too thin
            addLeft = helpsign.width();
            popup.css("top", offset.top - subtractTop);
            if (window.innerWidth <= 719) {
                popup.css("left", 0);
                popup.css("right", 0);
                popup.css("max-width", "none");
                subtractTop = subtractTop + 16;
            }
            else {
                popup.css("left", offset.left + addLeft);
                popup.css("max-width", "600px");
            }
            subtractTop = popup.outerHeight();
        }
    }

    $("span.hover-help").on("click", function () {
        if ($(".hover-help-popup").length >= 0) {
            $(".hover-help-popup").remove();
        }
        $("body").append("<div class='hover-help-popup' data-helpsign-id='" + $(this).attr("id") + "'>" + $(this).data("text") + "</div>");
        positionPopup($(this), $(".hover-help-popup"));
    });
    $("body").on("click", ".hover-help-popup, span.hover-help", function (e) {
        if ($(".hover-help-popup").length === 1) {
            e.stopPropagation();
        }
    });
    $(window).on("click", function () {
        $(".hover-help-popup").remove();
    });
    $(window).on("resize",function () {
        positionPopup($("#" + $(".hover-help-popup").data("helpsign-id")), $(".hover-help-popup"));
    });
}